export default function TrustSection() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <p className="text-xs md:text-sm font-medium font-heading italic text-foreground-400 mb-4">
            Trusted by smart shoppers worldwide
          </p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading leading-[1.1] text-foreground-950">
            The spreadsheet that
            <br />
            <span className="italic font-normal text-accent-500">changes how you shop</span>
            <br />
            across borders
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-xl leading-relaxed">
            Thousands of cross-border shoppers rely on our spreadsheet system to save time,
            reduce mistakes, and discover better deals every single day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-primary-100 rounded-3xl p-8 md:p-10 relative overflow-hidden group cursor-default">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="absolute top-8 right-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/60 hover:bg-white/80 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-up-line text-lg text-foreground-800" />
            </a>
            <p className="text-6xl md:text-7xl font-heading font-bold text-foreground-950 mb-3">98%</p>
            <p className="text-base md:text-lg text-foreground-700 font-medium mb-1">
              Satisfaction Rate
            </p>
            <p className="text-sm text-foreground-500 max-w-xs leading-relaxed">
              Users report a simpler, faster shopping workflow after adopting the Superbuy Spreadsheet system.
            </p>
            <p className="mt-6 text-xs text-foreground-400 italic">
              Based on 2,400+ user surveys
            </p>
          </div>

          <div className="bg-accent-100 rounded-3xl p-8 md:p-10 relative overflow-hidden group cursor-default">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="absolute top-8 right-8 w-12 h-12 flex items-center justify-center rounded-full bg-white/60 hover:bg-white/80 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-up-line text-lg text-foreground-800" />
            </a>
            <p className="text-6xl md:text-7xl font-heading font-bold text-foreground-950 mb-3">3.2x</p>
            <p className="text-base md:text-lg text-foreground-700 font-medium mb-1">
              Faster Checkout Process
            </p>
            <p className="text-sm text-foreground-500 max-w-xs leading-relaxed">
              On average, users complete their cross-border purchases over three times faster
              with our organized spreadsheet workflow compared to manual tracking methods.
            </p>
            <p className="mt-6 text-xs text-foreground-400 italic">
              Measured across 15,000+ shopping sessions
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}